export class B2BCesta {
  cabid: number;
  linid: number;
  codart: string;
  nomart: string;
  fecha: Date;
  canofe: number;
  precio: number;
  descuento: string;
  impnet: number;
  imptot: number;
  tercer: string;
  dtob2b: number;
  refter: string;
  direnv: string;
  coment: string;
  fecent: Date;
  tipdoc: string;
  cabori: number;
  tiptra: string;
  portes: string;
  updpre: number;
  constructor() {}
}
